export default __webpack_public_path__ + "img/85027f3b6a5c3bfc19def5f4bde5ff5d.png";